import React from 'react'
import { InputNumber } from 'primereact/inputnumber';
import { Trans } from 'react-i18next';
import { useTranslation } from 'react-i18next';


export const AmountInputNumber = (props) => {
    const { policyType, formik, getFormErrorMessage, defMembership } = props;
    const { t } = useTranslation("common");

    const amountCurrency = defMembership?.business?.currency;


    return (
        <div>
            {(policyType !== "CUSTOM") ? (<span> { } </span>) :
                (<div>
                    <div className="title" style={{ margin: "1rem 0 0.3rem 0" }}>{t("amount")} <span className="isterik">*</span></div>
                    <div style={{ marginBottom: "0.5rem" }}>
                        <InputNumber
                            id="amount amt"
                            name="amount"
                            style={{ height: "3rem", width: "100%" }}
                            value={formik.values.amount}
                            onKeyDown={(e) => {
                                const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab", "."];
                                if (!allowedKeys.includes(e.key) && !/^\d$/.test(e.key)) {
                                    e.preventDefault();
                                    return;
                                }
                                const initialValue = String(formik.values.amount ?? "");
                                if (e.key === "." && initialValue.includes(".")) {
                                    e.preventDefault();
                                    return;
                                }
                                const parts = initialValue.split(".");
                                const wholePartLength = parts[0]?.length || 0;
                                const selection = window.getSelection().toString();
                                if (
                                    /^\d$/.test(e.key) &&
                                    wholePartLength >= 5 &&
                                    !initialValue.includes(".") &&
                                    selection.length === 0
                                ) {
                                    e.preventDefault();
                                    formik.setFieldError("amount", "invitation.subscription_amount_range");

                                } else {
                                    formik.setFieldError("amount", null);
                                }
                            }}
                            onChange={(e) => {
                                const value = e.value;
                                if (value && value > 99999) {
                                    formik.setFieldError("amount", "invitation.subscription_amount_range");
                                    return;
                                }
                                formik.setFieldValue("amount", value);
                                formik.setFieldTouched("amount", true, false);

                                if (value !== null && value !== undefined) {
                                    if (value < 1 || value > 10000) {
                                        formik.setFieldError("amount", "invitation.subscription_amount_range");
                                    } else {
                                        formik.setFieldError("amount", null);
                                    }
                                } else {
                                    formik.setFieldError("amount", null);
                                }
                            }}

                            onBlur={(e) => {
                                formik.handleBlur(e);
                                formik.validateField("amount");
                            }}
                            mode="currency"
                            currency={defMembership.business.currency}
                            maxFractionDigits={2}
                            useGrouping={true}
                            placeholder={`${t("invitation.amount")} (${defMembership.business.currency})`}
                            max={99999}
                            min={0}
                            pt={{
                                input: {
                                    root: {
                                        autocomplete: 'off'
                                    }
                                }
                            }}
                        />
                    </div>
                    {formik.errors.amount !== "invitation.subscription_amount_range" &&
                        getFormErrorMessage("amount")}

                    {formik.touched.amount &&
                        formik.errors.amount === "invitation.subscription_amount_range" && (
                            <Trans i18nKey="invitation.subscription_amount_range"
                                values={{
                                    currency: amountCurrency,
                                    minAmount: "1.00",
                                    maxAmount: "10,000.00"
                                }}
                                components={{
                                    1: <span className="inv_deduction_errors"></span>,
                                    2: <span className="inv_deduction_errors"></span>,
                                    3: <span className="inv_deduction_errors"></span>,
                                    4: <span className="inv_deduction_errors"></span>,
                                    5: <span className="inv_deduction_errors"></span>,
                                    6: <span className="inv_deduction_errors"></span>
                                }}>
                            </Trans>
                        )}
                </div>)
            }

            {policyType !== "TARGET" ? <span>{ }</span> :
                (<div>
                    <p className="title" style={{ margin: "1rem 0 0.3rem 0" }}>{t("plan.target_cost")}
                        <span className="isterik">*</span>
                    </p>
                    <div style={{ marginBottom: "0.5rem" }}>
                        <InputNumber
                            id="target"
                            name="target"
                            style={{ height: "3rem", width: "100%" }}
                            value={formik.values.target}
                            placeholder={`${t("plan.enter_target_amount")}`}
                            mode="currency"
                            currency={defMembership.business.currency}
                            maxFractionDigits={2}
                            useGrouping={true}
                            max={99999}
                            pt={{
                                input: {
                                    root: {
                                        autocomplete: 'off'
                                    }
                                }
                            }}
                            onKeyDown={(e) => {
                                const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab", "."];
                                if (!allowedKeys.includes(e.key) && !/^\d$/.test(e.key)) {
                                    e.preventDefault();
                                    return;
                                }
                                const currentValue = String(formik.values.target ?? "");
                                if (e.key === "." && currentValue.includes(".")) {
                                    e.preventDefault();
                                    return;
                                }
                                const parts = currentValue.split(".");
                                const wholePartLength = parts[0]?.length || 0;
                                const selection = window.getSelection().toString();
                                if (
                                    /^\d$/.test(e.key) &&
                                    wholePartLength >= 5 &&
                                    !currentValue.includes(".") &&
                                    selection.length === 0
                                ) {
                                    e.preventDefault();
                                    formik.setFieldError("target", t("invitation.target_range_error"));
                                } else {
                                    formik.setFieldError("target", null);
                                }
                            }}

                            onChange={(e) => {
                                const value = e.value;
                                if (value && value > 99999) {
                                    formik.setFieldError("target", t("invitation.target_range_error"));
                                    return;
                                }
                                formik.setFieldValue("target", value);
                                formik.setFieldTouched("target", true, false);

                                if (value !== null && value !== undefined) {
                                    if (value < 100 || value > 50000) {
                                        formik.setFieldError("target", t("invitation.target_range_error"));
                                    } else {
                                        formik.setFieldError("target", null);
                                    }
                                } else {
                                    formik.setFieldError("target", null);
                                }
                            }}

                            onBlur={(e) => {
                                formik.handleBlur(e);
                                formik.validateField("target");
                            }}
                        />
                    </div>
                    {getFormErrorMessage("target")}
                </div>)}
        </div>
    )
}
